export { navigateToHash } from './navigate-to-hash';
